import { useState } from "react"
import useNotification from "../../../../hooks/useNotification"

import useApi from "../../../../hooks/useApi"
import SpinnerButton from "../../../generic/SpinnerButton"
import generateEndpoint from "../../../../utils/generateEndpoint"
import { useParams } from "react-router-dom"
import useTranslation from "../../../../hooks/useTranslation"
import runLogic from "../../../../../../common/logic/runLogic"
import resolveParams from "../../../../../../common/model/utilities/resolveParams"
import { useQueryClient } from "@tanstack/react-query"


const Action = ({ action, entity, useStore }) => {

    const [data, setData] = useState(null)

    const [state, setState] = useStore(s => s)
    const { showNotification, NotificationComponent } = useNotification();
    
    const { postMe } = useApi()
    const label = action['buttonLabel']

    const path = action.endpoint
    const params = useParams()

    const { t } = useTranslation()
    const queryClient = useQueryClient()


    const { id } = params
    const endpoint = generateEndpoint(path, id)


    // What to post, declared.
    //
    // This sent `state` — the whole form store, whatever it happened to hold —
    // so the body was an accident of what the page had loaded. It carried
    // `loaded` to the server on every request, a render flag `PageView` writes
    // into the same store, along with settings, addresses and every other
    // column. Neither rule behind these buttons reads any of it: reserve
    // touches the body only in its `construct` step and unreserve only in its
    // first `load`, and both reload the document from the database after that.
    //
    // `body` names what each one needs, through the same `resolveParams` that
    // builds every process-view body (33.2 step 9). `record` is the form state,
    // the vocabulary `optimisticLogicData` already uses. It narrows top-level
    // keys and does not reshape arrays — `lines` still goes over whole, because
    // resolveParams has no element-mapping form.
    const body = action.body ? resolveParams(action.body, { record: state }) : state

    const sendRequest = async (e) => {
        e.preventDefault()
        const response = await postMe(endpoint, body)
        console.log('<Data> Here is the response : ', response)
        //setData(response)
        if (response.status === 'success') {
            showNotification(response.title, response.message, 'success')
            const processedData = runLogic(response.data, entity)
            setState(processedData)

            if (action.invalidateQuery) {
                try {
                    await queryClient.invalidateQueries({
                        queryKey: [action.invalidateQuery],
                        refetchType: 'all'
                    })
                } catch (err) {
                    console.error('Failed to invalidate queries', err)
                }
            }
        } else {
            showNotification(response.title, response.error, 'error')
        }
    }

    return (
        <div>
            {NotificationComponent}
            <SpinnerButton onClickEvent={(e) => sendRequest(e)} testId={`${action.name}.button`}>{t(label)}</SpinnerButton>
        </div>
    )
}

export default Action
